import { footer, mainNav, type SiteDef  } from '@luxfi/ui/site-def'

import { commerceConfig as commerce }  from '@luxfi/data/commerce'

export default {
  app: 'market',
  currentAs: 'https://lux.market',
  nav: {
    common: mainNav,
  },
  footer: footer.standard, 
  chatbot: {
    suggestedQuestions: [
      { heading: 'Protocol royalties', message: 'How do protocol-enforced royalties work?' },
      { heading: 'Create', message: 'How do I mint an NFT?' },
      { heading: 'Fees', message: 'What are the fees to trade?' }
    ]
  },
  commerce,
} satisfies SiteDef
